// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arbok: PokeData = {
  "id": 24,
  "name": "arbok",
  "height": 35,
  "weight": 650,
  "base_experience": 157,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "slam",
    "wrap",
    "poison-sting",
    "leer",
    "bite",
    "acid",
    "toxic",
    "screech",
    "haze",
    "glare",
    "sludge-bomb",
    "crunch",
    "stockpile",
    "spit-up",
    "swallow",
    "gastro-acid",
    "sucker-punch",
    "poison-jab",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "mud-bomb",
    "gunk-shot",
    "coil",
    "acid-spray",
    "belch"
  ],
  "moves": [
    "leer",
    "bite",
    "acid",
    "sludge-bomb",
    "crunch",
    "poison-jab",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "mud-bomb",
    "toxic-spikes",
    "toxic-overload",
    "poison-powder"
  ],
  "evolution_chain": {
    "id": 9,
    "item": null,
    "species": [
      {
        "name": "ekans",
        "order": 23,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arbok",
        "order": 24,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 23,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 132,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
